import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You could send errorInfo to a logging service here
    // eslint-disable-next-line no-console
    console.error('Unhandled error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24 }}>
          <h2>Beklenmeyen bir hata oluştu.</h2>
          <p>Sayfayı yenilemeyi deneyin. Hata devam ederse lütfen bildirin.</p>
        </div>
      );
    }
    return this.props.children;
  }
}


